import css from './index.module.scss';
import { useState, useEffect } from 'react';
import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';
import EfImg from '@elem/ui/ef-img';
import EfSection from '@elem/ui/ef-section';

interface ItemProps {
    title: string;
    desc: object[];
}
export default function G() {
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [enter, setEnter] = useState(false);
    const items: ItemProps[] = [
        {
            title: t('NEW1_item1_title'),
            desc: [
                {
                    title: t('subTitle1'),
                    desc: t('NEW1_item1_text1'),
                },
                {
                    title: t('subTitle2'),
                    desc: t.rich('NEW1_item1_text2', {
                        w: (child: string) => <span className="orange-text">{child}</span>,
                    }),
                },
                {
                    title: t('subTitle3'),
                    desc: t('NEW1_item1_text3'),
                },
                {
                    title: t('subTitle4'),
                    desc: t('NEW1_item1_text4'),
                },
                {
                    title: t('subTitle5'),
                    desc: t('NEW1_item1_text5'),
                },
                {
                    title: t('subTitle6'),
                    desc: t('NEW1_item1_text6'),
                },
            ],
        },
        {
            title: t('NEW1_item2_title'),
            desc: [
                {
                    title: t('subTitle1'),
                    desc: t('NEW1_item2_text1'),
                },
                {
                    title: t('subTitle2'),
                    desc: t.rich('NEW1_item2_text2', {
                        w: (child: string) => <span className="orange-text">{child}</span>,
                    }),
                },
                {
                    title: t('subTitle3'),
                    desc: t('NEW1_item2_text3'),
                },
                {
                    title: t('subTitle4'),
                    desc: t('NEW1_item2_text4'),
                },
                {
                    title: t('subTitle5'),
                    desc: t('NEW1_item2_text5'),
                },
                {
                    title: t('subTitle6'),
                    desc: t('NEW1_item2_text6'),
                },
            ],
        },
    ];

    return (
        <section className={`dpu-new1 ${css['dpu-new1']}`}>
            <EfSpec />
            <EfSection desc={t('NEW1_desc')} title={t('NEW1_title')} />
            <div className="scroll">
                <div className="img-box">
                    <EfImg
                        pc="https://websiteoss.ecoflow.com/upload/image/1742960077223/new1.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1742960077056/new1_M.jpg"
                    />
                </div>
                <ul className="items">
                    {items?.map((item: ItemProps, k: number) => (
                        <li className="item" key={k}>
                            <p className="item-title">{item.title}</p>
                            <ul className="item-texts">
                                {item.desc?.map((text: any, m: number) => (
                                    <li className="item-text" key={k + '_' + m}>
                                        <p className="item-text-title"> {text.title}</p>
                                        <p className="item-text-desc"> {text.desc}</p>
                                    </li>
                                ))}
                            </ul>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
}
